import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  TextInput,
  TextField,
  EditButton,
} from "react-admin";
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'


const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />

  </Filter>
);

const MerchantIntentTesterLablesList = ({ ...props }) => {
  return (
    <List
      {...props}
      title="Labels"

      filters={<ListFilter />}

    >
      <Datagrid rowClick={"show"}>
        <TextField source="id" />
        <TextField source="title" label="Title" />
        <TextField source="product_url" label="Product URL" />
        <TextField source="radio_label1" label="Label 1" />
        <TextField source="radio_label2" label="Label 2" />
        <TextField source="text_field_value" label="Text Input" />
        <TextField source="text_field_title" label="Text Input Title" />

        {useCheckPermissions('MerchantIntentTesterLabel_Edit') ? <EditButton /> : null}
      </Datagrid>
    </List>
  );
};

export default MerchantIntentTesterLablesList;
